import { render, staticRenderFns } from "./category-children.vue?vue&type=template&id=59c7784f&scoped=true&"
import script from "./category-children.vue?vue&type=script&lang=js&"
export * from "./category-children.vue?vue&type=script&lang=js&"
import style0 from "./category-children.vue?vue&type=style&index=0&id=59c7784f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c7784f",
  null
  
)

export default component.exports